import React, { Component, ErrorInfo, ReactNode } from "react";
interface ErrorBoundaryProps {
  children: ReactNode;
  resetKey?: string;
}
interface ErrorBoundaryState {
  error: Error | null;
}

/** Catches render errors so a broken screen never turns into a blank page. */
export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = {
    error: null
  };
  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return {
      error
    };
  }
  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Screen crashed:", error, info.componentStack);
  }
  componentDidUpdate(prev: ErrorBoundaryProps) {
    if (this.state.error && prev.resetKey !== this.props.resetKey) this.setState({
      error: null
    });
  }
  render() {
    if (!this.state.error) return this.props.children;
    return <div className="pat-dots flex min-h-screen w-full items-center justify-center bg-paper px-5 font-sans text-ink" data-id="element-512" data-mp="a5mz6inny8jg">
        <div role="alert" className="w-full max-w-md rounded-panel border-3 border-line bg-surface p-7 shadow-brutal-lg" data-id="element-513" data-mp="f2n58tkijbak">
          <p className="inline-block rounded-lg bg-peach px-2.5 py-1 text-sm font-bold text-ink" lang="es" data-id="element-514" data-mp="32wcp5u7nogr4">
            ¡Ay!
          </p>
          <h1 className="mt-4 text-2xl font-bold tracking-[-0.02em]" data-id="element-515" data-mp="2y4l8qci7rrep">This screen hit a snag</h1>
          <p className="mt-2 text-[15px] leading-relaxed text-ink-2" data-id="element-516" data-mp="2u3rl7k8ooemc">
            Your progress is safe. Try again, or head back to your dashboard.
          </p>
          <pre className="mt-4 max-h-28 overflow-auto rounded-xl bg-sunken p-3 text-xs text-ink-2" data-id="element-517" data-mp="2k5txqyynelus">{this.state.error.message}</pre>
          <div className="mt-6 flex flex-wrap gap-3" data-id="element-518" data-mp="2f81tr6kqb9a8">
            <button type="button" onClick={() => this.setState({
            error: null
          })} className="focus-ring rounded-xl border-3 border-line bg-accent px-4 py-2.5 text-sm font-semibold text-night shadow-brutal-sm" data-id="element-519" data-mp="2b5osovgxfzjs">
              Try again
            </button>
            <a href="/app" className="focus-ring rounded-xl border-3 border-line bg-surface px-4 py-2.5 text-sm font-semibold text-ink shadow-brutal-sm" data-id="element-520" data-mp="22xasrfw3amcv">
              Back to dashboard
            </a>
          </div>
        </div>
      </div>;
  }
}